import { useContext, createContext } from 'react';

import { FooterProps } from '../@types/FooterProps';

export const FooterContext = createContext<FooterProps>({} as FooterProps);

FooterContext.displayName = 'Footer';

const FooterProvider = (props: FooterProps) => (
	<FooterContext.Provider value={props}>{props.children}</FooterContext.Provider>
);

export const useFooter = () => {
	const context = useContext(FooterContext);

	return context;
};

export default FooterProvider;
